import { createSelector } from "reselect";

const categoriesState = (state) => state.categories;

export const isLoading = createSelector(categoriesState, (categories) => categories.all.loading);
export const selectAllCategories = createSelector(categoriesState, (categories) => categories.all.items);
export const selectAllSubcategories = createSelector(categoriesState, (categories) =>
  categories.all.included.filter((subcat) => subcat.type === "subcategory")
);
